export default "__VITE_ASSET__BJpzXUfG__"